import React, { useContext, useEffect, useRef, useState } from 'react';
import { StoreContext } from 'store';
import { LOCALES } from '../../localisation';
import type { Locale as LocaleType } from '../../localisation';
import './locale.scss';
import { Text } from 'components/Text';

const LOCALE_STORAGE_KEY = 'tpc-locale';

const Locale = () => {
  const [isOpened, setIsOpened] = useState(false);

  const {
    localisation: [locale, setLocale],
  } = useContext(StoreContext);
  const [text] =
    Object.entries(LOCALES).find(([key, value]) => {
      return value === locale;
    }) || [];

  const localeRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    document.addEventListener('click', event => {
      if (event.target !== localeRef.current) setIsOpened(false);
    });
  }, []);

  const options = Object.entries(LOCALES).map(([key, value]) => {
    return (
      <Text.CapsM
        key={key}
        onClick={() => onChange(value)}
        className={'c-locale__option ' + (value === locale ? 'current' : '')}
      >
        {key}
      </Text.CapsM>
    );
  });

  const onClick = () => {
    setIsOpened(!isOpened);
  };

  const onChange = (locale: LocaleType) => {
    setLocale(locale);
    setIsOpened(false);

    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  };

  return (
    <div ref={localeRef} className="c-locale" onClick={onClick}>
      {text}
      {isOpened ? (
        <div className="c-locale__options">
          <svg
            width="8"
            height="5"
            viewBox="0 0 8 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M4 0L0 5H8L4 0Z" fill="#F2C94C" />
          </svg>
          {options}
        </div>
      ) : null}
    </div>
  );
};

export { Locale, LOCALE_STORAGE_KEY };
